import React from 'react';

function SelectField({
  label,
  Icon,
  name,
  value,
  onChange,
  disabled = false,
  children,
  error,
}) {
  return (
    <div className="form-field">
      <div className="field-label">
        {Icon ? <Icon /> : null}
        {label}
      </div>
      <div className="input-group">
        <div className="input-with-error">
          <select
            className="inputselect"
            name={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
          >
            {children}
          </select>
          {error && <span className="error-message">{error}</span>}
        </div>
      </div>
    </div>
  );
}

export default SelectField;
